import React, { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { BaseEntite } from '../../../../common/src/entities';
import { ValueType } from 'react-select';
import DropdownEntite, { PropsDeDropdownEntite } from './DropdownEntite';

export type PropsDeDropdownEntiteFormulaire<TEntite extends BaseEntite, TForm> = PropsDeDropdownEntite<TEntite> & {
    id: keyof TForm;
    appendedChildren?: ReactElement;
};

export default function DropdownEntiteFormulaire<TEntite extends BaseEntite, TFormulaire>(
    props: PropsDeDropdownEntiteFormulaire<TEntite, TFormulaire>,
): ReactElement {
    const { id, appendedChildren, champs } = props;
    const { touched, errors, setFieldValue, values } = useFormikContext<TFormulaire>();
    return (
        <DropdownEntite
            enErreur={touched[id] && !!errors[id]}
            erreur={String(errors[id])}
            onChange={(valeur: ValueType<TEntite, false>) => {
                setFieldValue(id, (valeur as TEntite)?.id ?? null);
                setFieldValue(champs, valeur);
            }}
            valeur={(data) => data?.find((obj) => obj.id == ((values[id] as unknown) as number)) ?? null}
            {...props}
            avecUnBouton={appendedChildren ? true : false}
        />
    );
}
